import { InvoiceSummaryWithCustomerJobData } from '../../../domain/invoicing/invoice'

export type SplitStatementInvoices = {
  thisJob: InvoiceSummaryWithCustomerJobData | null
  otherJobs: InvoiceSummaryWithCustomerJobData[]
}

export const splitStatementInvoices = (
  invoices: InvoiceSummaryWithCustomerJobData[],
  currentInvoiceId: string
): SplitStatementInvoices => ({
  thisJob: invoices.find(invoice => invoice.invoiceId === currentInvoiceId) ?? null,
  otherJobs: invoices.filter(invoice => invoice.invoiceId !== currentInvoiceId)
})
